import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "flex w-full flex-col md:flex-row" }
const _hoisted_2 = { class: "hidden md:block bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_3 = { class: "flex justify-end mt-7" }
const _hoisted_4 = { class: "bg-white border-2 border-gray-400 rounded-md p-4" }
const _hoisted_5 = { class: "grid gap-4" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = { class: "flex justify-end mt-7" }
const _hoisted_8 = { class: "flex justify-end items-center md:flex-grow" }
const _hoisted_9 = {
  class: "md:hidden",
  style: {"height":"calc(100vh - 177px)"}
}
const _hoisted_10 = { class: "custom-title flex flex-col" }
const _hoisted_11 = { class: "ml-auto" }
const _hoisted_12 = { class: "flex items-center space-x-1" }
const _hoisted_13 = { style: {"height":"calc(100vh - 227px)","overflow-y":"auto"} }
const _hoisted_14 = {
  key: 0,
  class: "flex-grow"
}
const _hoisted_15 = { key: 1 }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "hidden md:block w-full" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "flex w-full justify-end mt-4" }
const _hoisted_20 = { class: "hidden md:block mr-3" }
const _hoisted_21 = { class: "md:hidden" }
const _hoisted_22 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OrganizationSelect = _resolveComponent("OrganizationSelect")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_DepartmentSelect = _resolveComponent("DepartmentSelect")!
  const _component_AutoCompleteInput = _resolveComponent("AutoCompleteInput")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_drawer = _resolveComponent("el-drawer")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_mian = _resolveComponent("el-mian")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { style: {"height":"calc(100vh - 52px)"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, {
          style: {"height":"auto"},
          class: "bg-gray-200 p-3 md:p-5"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_el_form, {
                  model: _ctx.searchForm,
                  "label-width": "auto",
                  "label-position": "top"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(["grid gap-4", [
                            _ctx.loginUserRole === _ctx.ROLES.SYSTEM ? 'md:grid-cols-4' : _ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead ? 'md:grid-cols-3' : 'md:grid-cols-2',
                        ]])
                    }, [
                      _withDirectives(_createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "組織"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_OrganizationSelect, {
                            modelValue: _ctx.searchForm.organization_id,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                            "is-search": true,
                            placeholder: "組織を選択"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                      ]),
                      _withDirectives(_createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "部門"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_DepartmentSelect, {
                            "organization-id": _ctx.searchForm.organization_id,
                            "is-search": true,
                            modelValue: _ctx.searchForm.department_id,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchForm.department_id) = $event)),
                            placeholder: "部門を選択",
                            onOrganizationIdChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchForm.organization_id = $event))
                          }, null, 8, ["organization-id", "modelValue"])
                        ]),
                        _: 1
                      }, 512), [
                        [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
                      ]),
                      _createVNode(_component_el_form_item, {
                        class: "no-margin",
                        label: "ユーザー名"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_AutoCompleteInput, {
                            modelValue: _ctx.searchForm.username,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searchForm.username) = $event)),
                            placeholder: "ユーザー名を入力",
                            "storage-key": "user-name-history",
                            "max-history-items": 15,
                            ref: "usernameInput"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_3, [
                        _createVNode(_component_el_button, {
                          class: "hidden md:block w-24",
                          type: "info",
                          onClick: _ctx.handleSearchButton
                        }, {
                          default: _withCtx(() => _cache[31] || (_cache[31] = [
                            _createTextVNode("検索")
                          ])),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["model"])
              ]),
              _createVNode(_component_el_drawer, {
                class: "md:hidden bg-gray-200",
                modelValue: _ctx.drawer,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.drawer) = $event)),
                title: "検索",
                direction: "ttb",
                "with-header": false,
                size: "auto"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_el_form, {
                      model: _ctx.searchForm,
                      "label-width": "auto",
                      "label-position": "top"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          _withDirectives(_createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "組織"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_OrganizationSelect, {
                                modelValue: _ctx.searchForm.organization_id,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.searchForm.organization_id) = $event)),
                                "is-search": true,
                                placeholder: "組織を選択"
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM]
                          ]),
                          _withDirectives(_createVNode(_component_el_form_item, {
                            class: "no-margin",
                            label: "部門"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_DepartmentSelect, {
                                "organization-id": _ctx.searchForm.organization_id,
                                "is-search": true,
                                modelValue: _ctx.searchForm.department_id,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.searchForm.department_id) = $event)),
                                placeholder: "部門を選択",
                                onOrganizationIdChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.searchForm.organization_id = $event))
                              }, null, 8, ["organization-id", "modelValue"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, _ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead)]
                          ]),
                          _createElementVNode("div", _hoisted_6, [
                            _createVNode(_component_el_form_item, {
                              class: "no-margin flex-grow",
                              label: "ユーザー名"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_AutoCompleteInput, {
                                  modelValue: _ctx.searchForm.username,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchForm.username) = $event)),
                                  placeholder: "ユーザー名を入力",
                                  "storage-key": "user-name-history",
                                  "max-history-items": 15,
                                  ref: "usernameInput"
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_el_button, {
                                class: "md:hidden ml-3",
                                type: "info",
                                onClick: _ctx.handleSearchButton,
                                circle: ""
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_el_icon, null, {
                                    default: _withCtx(() => _cache[32] || (_cache[32] = [
                                      _createElementVNode("span", { class: "material-symbols-outlined" }, "manage_search", -1)
                                    ])),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["model"])
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn md:hidden",
                  type: "info",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.drawer = true)),
                  circle: ""
                }, {
                  default: _withCtx(() => _cache[33] || (_cache[33] = [
                    _createElementVNode("span", { class: "material-symbols-outlined" }, " manage_search ", -1)
                  ])),
                  _: 1
                }),
                (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "custom-icon-btn md:hidden",
                      type: "info",
                      onClick: _ctx.handleAddButton,
                      circle: ""
                    }, {
                      default: _withCtx(() => _cache[34] || (_cache[34] = [
                        _createElementVNode("span", { class: "material-symbols-outlined" }, " add ", -1)
                      ])),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      class: "hidden md:block w-24",
                      type: "info",
                      onClick: _ctx.handleAddButton
                    }, {
                      default: _withCtx(() => _cache[35] || (_cache[35] = [
                        _createTextVNode("新規登録")
                      ])),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                  ? (_openBlock(), _createBlock(_component_el_upload, {
                      key: 2,
                      class: "",
                      ref: "upload",
                      "on-change": _ctx.handleImportButton,
                      "auto-upload": false,
                      "show-file-list": false,
                      accept: ".csv"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_tooltip, {
                          content: "CSVインポート",
                          placement: "top"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              class: "custom-icon-btn mx-3",
                              type: "info",
                              circle: ""
                            }, {
                              default: _withCtx(() => _cache[36] || (_cache[36] = [
                                _createElementVNode("span", { class: "material-symbols-outlined" }, " upload_2 ", -1)
                              ])),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["on-change"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_button, {
                  class: "custom-icon-btn",
                  type: "info",
                  onClick: _ctx.handleExportButton,
                  circle: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_tooltip, {
                      content: "CSVエクスポート",
                      placement: "top"
                    }, {
                      default: _withCtx(() => _cache[37] || (_cache[37] = [
                        _createElementVNode("span", { class: "material-symbols-outlined" }, " download_2 ", -1)
                      ])),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_mian, { style: {"padding-bottom":"20px"} }, {
          default: _withCtx(() => [
            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _cache[40] || (_cache[40] = _createElementVNode("span", null, "ユーザーマスタ（ユーザー名　役割）", -1)),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _cache[39] || (_cache[39] = _createElementVNode("span", { class: "text-white" }, "ソート:", -1)),
                    _createVNode(_component_el_button, {
                      size: "small",
                      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.handleSort('username'))),
                      class: _normalizeClass(['mobile-sort-btn', _ctx.sortField === 'username' ? 'active' : ''])
                    }, {
                      default: _withCtx(() => _cache[38] || (_cache[38] = [
                        _createTextVNode(" ユーザー名 ")
                      ])),
                      _: 1
                    }, 8, ["class"]),
                    _createElementVNode("span", null, "アイテム数: " + _toDisplayString(_ctx.mTotalRecords), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mTableData, (item) => {
                  return (_openBlock(), _createBlock(_component_el_card, {
                    style: {"border":"1px solid #d1d5db","border-radius":"0px"},
                    key: item.user_id
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { align: "middle" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 2 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                class: "w-8 h-16",
                                type: "info",
                                style: {"background-color":"#b7b7b7"},
                                text: "",
                                bg: "",
                                onClick: ($event: any) => (_ctx.handleEditButton(item))
                              }, {
                                default: _withCtx(() => _cache[41] || (_cache[41] = [
                                  _createElementVNode("span", null, [
                                    _createTextVNode("詳"),
                                    _createElementVNode("br"),
                                    _createTextVNode("細")
                                  ], -1)
                                ])),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 18,
                            class: "ml-2"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_row, { align: "middle" }, {
                                default: _withCtx(() => [
                                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item.organization_name), 1))
                                    : _createCommentVNode("", true),
                                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(item.department_name), 1))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024),
                              _createElementVNode("div", null, _toDisplayString(item.username), 1),
                              _createVNode(_component_el_row, {
                                align: "middle",
                                justify: "space-between"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    (item.organization_id === _ctx.SYSTEM_ORGANIZATION && item.is_admin === '1')
                                      ? (_openBlock(), _createBlock(_component_el_tag, {
                                          key: 0,
                                          type: "warning"
                                        }, {
                                          default: _withCtx(() => _cache[42] || (_cache[42] = [
                                            _createTextVNode("システム管理者")
                                          ])),
                                          _: 1
                                        }))
                                      : (item.is_admin === '1')
                                        ? (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 1,
                                            type: "danger"
                                          }, {
                                            default: _withCtx(() => _cache[43] || (_cache[43] = [
                                              _createTextVNode("管理者")
                                            ])),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_el_tag, {
                                            key: 2,
                                            type: "success"
                                          }, {
                                            default: _withCtx(() => _cache[44] || (_cache[44] = [
                                              _createTextVNode("ユーザー")
                                            ])),
                                            _: 1
                                          }))
                                  ]),
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_el_switch, {
                                      modelValue: item.is_actived,
                                      "onUpdate:modelValue": ($event: any) => ((item.is_actived) = $event),
                                      value: "item.is_actived",
                                      "active-value": "1",
                                      "inactive-value": "0",
                                      disabled: _ctx.loginUserId === item.user_id || (item.organization_id === _ctx.SYSTEM_ORGANIZATION && item.is_admin === '1'),
                                      onChange: ($event: any) => (_ctx.handleStatusChange(item))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_el_col, {
                            span: 2,
                            class: "ml-2",
                            align: "right"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.loginUserId !== item.user_id && !(item.organization_id === _ctx.SYSTEM_ORGANIZATION && item.is_admin === '1'))
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "material-symbols-outlined cursor-pointer mt-2",
                                    onClick: ($event: any) => (_ctx.handleDeleteButton(item))
                                  }, " delete ", 8, _hoisted_16))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ])
            ])), [
              [_directive_loading, _ctx.loading]
            ]),
            _createElementVNode("div", _hoisted_17, [
              _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                data: _ctx.mTableData,
                height: "calc(100vh - 260px)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "ユーザーマスタ",
                    width: "130",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_button, {
                        class: "w-12",
                        type: "info",
                        style: {"background-color":"#b7b7b7"},
                        text: "",
                        bg: "",
                        onClick: ($event: any) => (_ctx.handleEditButton(scope.row))
                      }, {
                        default: _withCtx(() => _cache[45] || (_cache[45] = [
                          _createElementVNode("span", null, "詳細", -1)
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "user_id",
                    label: "コード"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.handleSort('user_id')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('user_id')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'user_id' }])
                            }, _toDisplayString(_ctx.getSortIcon('user_id')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 0,
                        prop: "organization_name",
                        label: "所属組織"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "flex items-center cursor-pointer whitespace-nowrap",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.handleSort('organization_name')))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('organization_name')), 1),
                            _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'organization_name' }])
                                }, _toDisplayString(_ctx.getSortIcon('organization_name')), 3)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM || (_ctx.loginUserRole === _ctx.ROLES.ADMIN && _ctx.loginUserRoleIsHead))
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 1,
                        prop: "department_name",
                        label: "所属部門"
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "flex items-center cursor-pointer whitespace-nowrap",
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.handleSort('department_name')))
                          }, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('department_name')), 1),
                            _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", {
                                  class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'department_name' }])
                                }, _toDisplayString(_ctx.getSortIcon('department_name')), 3)
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_table_column, {
                    prop: "username",
                    label: "ユーザー名"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.handleSort('username')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('username')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'username' }])
                            }, _toDisplayString(_ctx.getSortIcon('username')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "is_admin",
                    label: "役割"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.handleSort('role')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('role')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'role' }])
                            }, _toDisplayString(_ctx.getSortIcon('role')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_tag, {
                        type: (scope.row.organization_id === _ctx.SYSTEM_ORGANIZATION && scope.row.is_admin === '1')
                                ? 'warning'
                                : (scope.row.is_admin === '1' ? 'danger' : 'success')
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString((scope.row.organization_id === _ctx.SYSTEM_ORGANIZATION && scope.row.is_admin === '1')
                                    ? 'システム管理者'
                                    : (scope.row.is_admin === '1' ? '管理者' : 'ユーザー')), 1)
                        ]),
                        _: 2
                      }, 1032, ["type"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "email",
                    label: "メールアドレス"
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "flex items-center cursor-pointer whitespace-nowrap",
                        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.handleSort('email')))
                      }, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.getSortLabel('email')), 1),
                        _createVNode(_component_el_icon, { class: "ml-1 flex-shrink-0" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", {
                              class: _normalizeClass(["material-symbols-outlined text-sm", { 'text-blue-500': _ctx.sortField === 'email' }])
                            }, _toDisplayString(_ctx.getSortIcon('email')), 3)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, {
                    prop: "is_actived",
                    label: "有効/無効",
                    width: "86",
                    align: "center"
                  }, {
                    default: _withCtx((scope) => [
                      _createVNode(_component_el_switch, {
                        modelValue: scope.row.is_actived,
                        "onUpdate:modelValue": ($event: any) => ((scope.row.is_actived) = $event),
                        value: "scope.row.is_actived",
                        "active-value": "1",
                        "inactive-value": "0",
                        disabled: _ctx.loginUserId === scope.row.user_id || (scope.row.organization_id === _ctx.SYSTEM_ORGANIZATION && scope.row.is_admin === '1'),
                        onChange: ($event: any) => (_ctx.handleStatusChange(scope.row))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"])
                    ]),
                    _: 1
                  }),
                  (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
                    ? (_openBlock(), _createBlock(_component_el_table_column, {
                        key: 2,
                        label: "削除",
                        width: "52",
                        align: "center"
                      }, {
                        default: _withCtx((scope) => [
                          (_ctx.loginUserId !== scope.row.user_id && !(scope.row.organization_id === _ctx.SYSTEM_ORGANIZATION && scope.row.is_admin === '1'))
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "material-symbols-outlined cursor-pointer mt-2",
                                onClick: ($event: any) => (_ctx.handleDeleteButton(scope.row))
                              }, " delete ", 8, _hoisted_18))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["data"])), [
                [_directive_loading, _ctx.loading]
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createVNode(_component_el_pagination, {
                  "current-page": _ctx.mCurrentPage,
                  "onUpdate:currentPage": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.mCurrentPage) = $event)),
                  "page-size": _ctx.mPageSize,
                  "onUpdate:pageSize": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.mPageSize) = $event)),
                  "page-sizes": [10, 20, 50, 100],
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _ctx.mTotalRecords,
                  onSizeChange: _ctx.handleSizeChange,
                  onCurrentChange: _ctx.handlePageChange
                }, null, 8, ["current-page", "page-size", "total", "onSizeChange", "onCurrentChange"])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_el_pagination, {
                  layout: "prev, pager, next",
                  total: _ctx.mTotalRecords,
                  onCurrentChange: _ctx.handlePageChange
                }, null, 8, ["total", "onCurrentChange"])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      class: "custom-dialog",
      "modal-class": "custom-dialog-modal",
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.dialogFormVisible) = $event)),
      title: _ctx.form.add_update === 'add' ? '新規登録' : '詳細',
      "align-center": ""
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_button, {
            onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.dialogFormVisible = false))
          }, {
            default: _withCtx(() => _cache[46] || (_cache[46] = [
              _createTextVNode("キャンセル")
            ])),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.handleAddUpdateSubmit(_ctx.formRef)))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.form.add_update === 'add' ? '登録' : '更新'), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "コード",
              prop: "user_id",
              "label-width": "130px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.user_id,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.form.user_id) = $event)),
                  autocomplete: "off",
                  disabled: _ctx.form.add_update === 'update',
                  placeholder: "コード"
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "ユーザー名",
              prop: "username",
              "label-width": "130px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.username,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.form.username) = $event)),
                  autocomplete: "off",
                  placeholder: "ユーザー名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "メールアドレス",
              prop: "email",
              "label-width": "130px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.form.email,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.form.email) = $event)),
                  autocomplete: "off",
                  placeholder: "メールアドレス"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "パスワード",
              prop: "password",
              "label-width": "130px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  "show-password": "",
                  modelValue: _ctx.form.password,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.form.password) = $event)),
                  autocomplete: "off",
                  placeholder: _ctx.isEdit ? '変更する場合のみ入力' : 'パスワード'
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }),
            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "所属組織",
                  prop: "organization_id",
                  "label-width": "130px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_OrganizationSelect, {
                      modelValue: _ctx.form.organization_id,
                      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.form.organization_id) = $event)),
                      placeholder: "組織を選択",
                      disabled: _ctx.form.add_update === 'update'
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.loginUserRole === _ctx.ROLES.SYSTEM)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  label: "所属部門",
                  prop: "department_id",
                  "label-width": "130px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DepartmentSelect, {
                      "organization-id": _ctx.form.organization_id,
                      modelValue: _ctx.form.department_id,
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.form.department_id) = $event)),
                      placeholder: "部門を選択",
                      disabled: _ctx.form.add_update === 'update',
                      onOrganizationIdChange: _cache[25] || (_cache[25] = ($event: any) => (_ctx.form.organization_id = $event))
                    }, null, 8, ["organization-id", "modelValue", "disabled"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "役割",
              "label-width": "130px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.is_admin,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.form.is_admin) = $event)),
                  placeholder: "役割を選択"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "管理者",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "一般ユーザー",
                      value: "0"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "有効/無効",
              "label-width": "130px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.is_actived,
                  "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.form.is_actived) = $event)),
                  placeholder: "ステータスを選択",
                  disabled: _ctx.form.add_update === 'update' && (_ctx.loginUserId === _ctx.form.user_id || _ctx.form.organization_id === _ctx.SYSTEM_ORGANIZATION && _ctx.form.is_admin === '1')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: "有効",
                      value: "1"
                    }),
                    _createVNode(_component_el_option, {
                      label: "無効",
                      value: "0"
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}